import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FiAlertTriangle, FiCalendar, FiCheckCircle, FiChevronRight, FiClock, FiEdit3 } from 'react-icons/fi';
import testExamQuizIcon from '../../../assets/test_exam_quiz_icon.svg';
import styles from '../Dashboard.module.css';
import { getStatusIconClass } from './dashboardSummaryHelpers';

// The "My Quizzes & Exams" summary card. Extracted VERBATIM from
// DashboardSummaryCards' render.
export default function QuizzesSummaryCard({
  formatDueDate, getQuizStatus, handleQuizClick, quizSummary, recentQuizzes,
}) {
  return (
    <motion.div
      className={styles.summaryCard}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: 0.2 }}
    >
      <div className={styles.summaryHeader}>
        <h3 className={styles.summaryTitle}>
          <img src={testExamQuizIcon} alt="" className={styles.summaryTitleIcon} aria-hidden="true" />
          My Quizzes &amp; Exams
        </h3>
        <Link
          to="/student/quizzes"
          className={styles.viewAllButton}
        >
          View All
        </Link>
      </div>
      <div className={styles.summaryContent}>
        <div className={styles.summaryStats}>
          <div className={styles.summaryStatPill}>
            <span className={styles.summaryStatValue}>{quizSummary.open}</span>
            <span className={styles.summaryStatLabel}>Open</span>
          </div>
          <div className={styles.summaryStatPill}>
            <span className={styles.summaryStatValue}>{quizSummary.completed}</span>
            <span className={styles.summaryStatLabel}>Completed</span>
          </div>
          {quizSummary.overdue > 0 && (
            <div className={`${styles.summaryStatPill} ${styles.overdueChip}`}>
              <span className={styles.summaryStatValue}>{quizSummary.overdue}</span>
              <span className={styles.summaryStatLabel}>Overdue</span>
            </div>
          )}
        </div>
        <div className={styles.summaryItems}>
          {recentQuizzes.length > 0 ? (
            recentQuizzes.map((quiz, index) => {
              const status = getQuizStatus(quiz);
              const dueDateText = formatDueDate(quiz.assignment_due_at || quiz.quiz_due_at);
              return (
                <div
                  key={quiz.id || `quiz-${index}`}
                  className={styles.listRow}
                  onClick={() => handleQuizClick(quiz.assignment_id)}
                  role="button"
                  tabIndex={0}
                  aria-label={`${quiz.title}, due ${dueDateText}`}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleQuizClick(quiz.assignment_id);
                    }
                  }}
                >
                  <div className={getStatusIconClass(status)}>
                    {status === 'completed' ? <FiCheckCircle size={16} /> :
                     status === 'overdue' ? <FiAlertTriangle size={16} /> :
                     status === 'in-progress' ? <FiClock size={16} /> :
                     <FiEdit3 size={16} />}
                  </div>
                  <div className={styles.rowMain}>
                    <div className={styles.summaryItemTitle}>{quiz.title}</div>
                    <div className={styles.rowMeta}>
                      <FiCalendar size={12} />
                      {formatDueDate(quiz.assignment_due_at || quiz.quiz_due_at)}
                    </div>
                  </div>
                  <div className={styles.rowChevron}>
                    <FiChevronRight size={16} />
                  </div>
                </div>
              );
            })
          ) : (
            <div className={styles.emptySummary}>
              <FiEdit3 />
              <p>No quizzes yet</p>
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
}
